<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";

let vmsChangePermissionsConfig = {
    cId: "vmsChangePermissions",
    cType: "vmsChangePermissions",
    cTitle: "Set Permissions and Sharing",
    cTemplate: `<div :id="wrapperID" class="vmsChangePermissions-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div>
                        <div class="vmsChangePermissions-title">Set Permissions and Sharing</div>
                        <div>
                            <div>
                                <div class="vmsChangePermissions-header">
                                    <div class="vmsChangePermissions-header-whiteSpace"></div>
                                    <div class="vmsChangePermissions-header-permLabelList">
                                        <div class="vmsChangePermissions-header-permLabel">A</div>
                                        <div class="vmsChangePermissions-header-permLabel">GV</div>
                                        <div class="vmsChangePermissions-header-permLabel">PV</div>
                                        <div class="vmsChangePermissions-header-permLabel">PE</div>
                                        <div class="vmsChangePermissions-header-permLabel">E</div>
                                    </div>
                                </div>
                                <div class="vmsChangePermissions-header">
                                    <div class="vmsChangePermissions-header-whiteSpace">Permissions</div>
                                    <div class="vmsChangePermissions-header-permLabelList">
                                        <div class="vmsChangePermissions-header-permCheckbox">
                                            <control
                                                name="CHANGE_PERMISSIONS_A_CHECKBOX"
                                                :value="isCheckedAllPermissions('A')"
                                                v-on:change="(event) => changeAllPermissions(event, 'A')"
                                            ></control>
                                        </div>
                                        <div class="vmsChangePermissions-header-permCheckbox">
                                            <control
                                                name="CHANGE_PERMISSIONS_GV_CHECKBOX"
                                                :value="isCheckedAllPermissions('GV')"
                                                v-on:change="(event) => changeAllPermissions(event, 'GV')"
                                            ></control>
                                        </div>
                                        <div class="vmsChangePermissions-header-permCheckbox">
                                            <control
                                                name="CHANGE_PERMISSIONS_PV_CHECKBOX"
                                                :value="isCheckedAllPermissions('PV')"
                                                v-on:change="(event) => changeAllPermissions(event, 'PV')"
                                            ></control>
                                        </div>
                                        <div class="vmsChangePermissions-header-permCheckbox">
                                            <control
                                                name="CHANGE_PERMISSIONS_PE_CHECKBOX"
                                                :value="isCheckedAllPermissions('PE')"
                                                v-on:change="(event) => changeAllPermissions(event, 'PE')"
                                            ></control>
                                        </div>
                                        <div class="vmsChangePermissions-header-permCheckbox">
                                            <control
                                                name="CHANGE_PERMISSIONS_E_CHECKBOX"
                                                :value="isCheckedAllPermissions('E')"
                                                v-on:change="(event) => changeAllPermissions(event, 'E')"
                                            ></control>
                                        </div>
                                    </div>
                                </div>
                                <control class="vmsChangePermissions-listItemWrapper" name="CHANGE_PERMISSIONS_LIST" :items="permissionList"></control>
                            </div>
                            <div class="vmsChangePermissions-descriptionWrapper">
                                <span>* Some fields may be not editable because those fields were disabled for this Account.</span>
                            </div>
                        </div>
                    </div>
                    <div class="vmsChangePermissions-buttons">
                        <div class="vmsChangePermissions-button"><control name="CHANGE_PERMISSIONS_OK_BUTTON"></control></div>
                        <div class="vmsChangePermissions-button"><control name="CHANGE_PERMISSIONS_CANCEL_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'CHANGE_PERMISSIONS_LIST',
            type: 'list',
            itemContentTemplate: `
                <div class="vmsChangePermissions-listItem">
                    <div class="clientName">
                        Role: {{data.CLIENT_NAME}}
                    </div>
                    <div class="checkboxList">
                        <div class="permCheckbox">
                            <ejs-checkbox
                                v-on:change="(event) => component.changePermission(event, data, 'A')"
                                :checked="component.isPermissionChecked(data, 'A')"
                                :disabled="component.isPermissionDisable(data, 'A')"
                            ></ejs-checkbox>
                        </div>
                        <div class="permCheckbox">
                            <ejs-checkbox
                                v-on:change="(event) => component.changePermission(event, data, 'GV')"
                                :checked="component.isPermissionChecked(data, 'GV')"
                                :disabled="component.isPermissionDisable(data, 'GV')"
                            ></ejs-checkbox>
                        </div>
                        <div class="permCheckbox">
                            <ejs-checkbox
                                v-on:change="(event) => component.changePermission(event, data, 'PV')"
                                :checked="component.isPermissionChecked(data, 'PV')"
                                :disabled="component.isPermissionDisable(data, 'PV')"
                            ></ejs-checkbox>
                        </div>
                        <div class="permCheckbox">
                            <ejs-checkbox
                                v-on:change="(event) => component.changePermission(event, data, 'PE')"
                                :checked="component.isPermissionChecked(data, 'PE')"
                                :disabled="component.isPermissionDisable(data, 'PE')"
                            ></ejs-checkbox>
                        </div>
                        <div class="permCheckbox">
                            <ejs-checkbox
                                v-on:change="(event) => component.changePermission(event, data, 'E')"
                                :checked="component.isPermissionChecked(data, 'E')"
                                :disabled="component.isPermissionDisable(data, 'E')"
                            ></ejs-checkbox>
                        </div>
                    </div>
                </div>
                `,
            components: {
                "ejs-checkbox": defineAsyncComponent(() => import('@common/syncfusion/checkbox'))
            }
        },
        {
            name: 'CHANGE_PERMISSIONS_A_CHECKBOX',
            type: 'checkbox'
        },
        {
            name: 'CHANGE_PERMISSIONS_GV_CHECKBOX',
            type: 'checkbox'
        },
        {
            name: 'CHANGE_PERMISSIONS_PV_CHECKBOX',
            type: 'checkbox'
        },
        {
            name: 'CHANGE_PERMISSIONS_PE_CHECKBOX',
            type: 'checkbox'
        },
        {
            name: 'CHANGE_PERMISSIONS_E_CHECKBOX',
            type: 'checkbox'
        },
        // bottom buttons
        {
            name: 'CHANGE_PERMISSIONS_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
        {
            name: 'CHANGE_PERMISSIONS_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close',
        },
    ]
};

let vmsChangePermissionsCmp = {
    name: 'vmsChangePermissions',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        },
        permissions: {
            type: Object,
            default: []
        },
        saveCallback: {
            type: Function,
            default: null
        },
    },
    data() {
        return {
            permissionList: []
        };
    },
    computed: {
        wrapperID() {
            return this.cId + 'Wrapper';
        },
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        isCheckedAllPermissions(permissionName) {
            if (this.permissionList.length === 0) {
                return false;
            }
            let propName = null;
            let isAllChecked = true;
            if (permissionName === 'GV') {
                propName = 'PERMIT_GRID_VIEW';
            } else if (permissionName === 'PV') {
                propName = 'PERMIT_PROFILE_VIEW';
            } else if (permissionName === 'PE') {
                propName = 'PERMIT_PROFILE_EDIT';
            } else if (permissionName === 'E') {
                propName = 'PERMIT_EDITOR';
            }
            if (!propName) {
                for (let i = 0; i < this.permissionList.length && isAllChecked; i++) {
                    let clientData = this.permissionList[i];
                    if (
                        clientData.PERMIT_GRID_VIEW !== 1
                        || clientData.PERMIT_PROFILE_VIEW !== 1
                        || clientData.PERMIT_PROFILE_EDIT !== 1
                        || clientData.PERMIT_EDITOR !== 1
                    ) {
                        isAllChecked = false;
                    }
                }
                return isAllChecked;
            }
            for (let i = 0; i < this.permissionList.length && isAllChecked; i++) {
                if (this.permissionList[i][propName] !== 1) {
                    isAllChecked = false;
                }
            }
            return isAllChecked;
        },
        isPermissionChecked(clientData, permissionName) {
            switch (permissionName) {
                case 'A':
                    return clientData.PERMIT_GRID_VIEW === 1 && clientData.PERMIT_PROFILE_VIEW === 1 && clientData.PERMIT_PROFILE_EDIT === 1 && clientData.PERMIT_EDITOR === 1;
                case 'GV':
                    return clientData.PERMIT_GRID_VIEW === 1;
                case 'PV':
                    return clientData.PERMIT_PROFILE_VIEW === 1;
                case 'PE':
                    return clientData.PERMIT_PROFILE_EDIT === 1;
                case 'E':
                    return clientData.PERMIT_EDITOR === 1;
                default:
                    return false;
            }
        },
        isPermissionDisable(clientData, permissionName) {
            if (typeof clientData.caDisable !== 'object') {
                return false;
            }
            switch (permissionName) {
                case 'A':
                    return clientData.caDisable.disableGV === 1 && clientData.caDisable.disablePV === 1 && clientData.caDisable.disablePE === 1 && clientData.disableE === 1;
                case 'GV':
                    return clientData.caDisable.disableGV === 1;
                case 'PV':
                    return clientData.caDisable.disablePV === 1;
                case 'PE':
                    return clientData.caDisable.disablePE === 1;
                case 'E':
                    return clientData.disableE === 1;
                default:
                    return false;
            }
        },
        async onLoad() {
            this.$emit('update:vmsChangePermissionsLoaded', true);
            if (typeof this.permissions !== 'object') {
                this.permissions = [];
            }
            this.permissionList = [...this.permissions].sort((lhs, rhs) => lhs.CLIENT_NAME.localeCompare(rhs.CLIENT_NAME));
        },
        async changeAllPermissions(event, permissionName) {
            if (typeof event.checked === 'undefined') {
                return;
            }
            let isChecked = event.checked;

            this.permissionList.forEach((client) => {
                if (
                    (permissionName === 'A' || permissionName === 'GV')
                    && (typeof client.caDisable !== 'object' || client.caDisable.disableGV !== 1)
                ) {
                    client.PERMIT_GRID_VIEW = isChecked ? 1 : 0;
                }
                if (
                    (permissionName === 'A' || permissionName === 'PV')
                    && (typeof client.caDisable !== 'object' || client.caDisable.disablePV !== 1)
                ) {
                    client.PERMIT_PROFILE_VIEW = isChecked ? 1 : 0;
                }
                if (
                    (permissionName === 'A' || permissionName === 'PE')
                    && (typeof client.caDisable !== 'object' || client.caDisable.disablePE !== 1)
                ) {
                    client.PERMIT_PROFILE_EDIT = isChecked ? 1 : 0;
                }
                if (
                    (permissionName === 'A' || permissionName === 'E')
                    && (typeof client.caDisable !== 'object' || client.caDisable.disableE !== 1)
                ) {
                    client.PERMIT_EDITOR = isChecked ? 1 : 0;
                }
            });
        },
        async changePermission(event, clientData, permissionName) {
            if (typeof event.checked === 'undefined') {
                return;
            }
            let isChecked = event.checked;
            let client = this.permissionList.find((client) => client.CLIENT_ID === clientData.CLIENT_ID);
            if (!client) {
                return;
            }
            switch (permissionName) {
                case 'A':
                    if (typeof clientData.caDisable !== 'object' || clientData.caDisable.disableGV !== 1) {
                        client.PERMIT_GRID_VIEW = isChecked ? 1 : 0;
                    }
                    if (typeof clientData.caDisable !== 'object' || clientData.caDisable.disablePV !== 1) {
                        client.PERMIT_PROFILE_VIEW = isChecked ? 1 : 0;
                    }
                    if (typeof clientData.caDisable !== 'object' || clientData.caDisable.disablePE !== 1) {
                        client.PERMIT_PROFILE_EDIT = isChecked ? 1 : 0;
                    }
                    if (typeof clientData.caDisable !== 'object' || clientData.caDisable.disableE !== 1) {
                        client.PERMIT_EDITOR = isChecked ? 1 : 0;
                    }
                    break;
                case 'GV':
                    client.PERMIT_GRID_VIEW = isChecked ? 1 : 0;
                    break;
                case 'PV':
                    client.PERMIT_PROFILE_VIEW = isChecked ? 1 : 0;
                    break;
                case 'PE':
                    client.PERMIT_PROFILE_EDIT = isChecked ? 1 : 0;
                    break;
                case 'E':
                    client.PERMIT_EDITOR = isChecked ? 1 : 0;
                    break;
            }
        },
        async save() {
            if (typeof this.saveCallback === 'function') {
                let permissionList = library.cloneObj(this.permissionList);
                this.saveCallback(permissionList);
            }
            this.close();
        },
        close() {
            if (/openvmsChangePermissions/g.test(window.name)) {
                window.close();
            } else if (
                this.$parent
                && this.$parent.$parent
                && this.$parent.$parent.$parent
                && typeof this.$parent.$parent.$parent.componentDialogs === 'object'
                && this.$parent.$parent.$parent.componentDialogs.length
            ) {
                this.$parent.$parent.$parent.componentDialogs.find((component) => component.name === 'openvmsChangePermissions')?.cancelButton?.click();
            }
        },
    }
};

componentStore.initComponent(vmsChangePermissionsCmp, vmsChangePermissionsConfig);
export { vmsChangePermissionsConfig, vmsChangePermissionsCmp };
export default vmsChangePermissionsCmp;
</script>

<style>
#dialog_container_openvmsChangePermissions, #dialog_container_openvmsChangePermissions > div {
    min-height: 200px;
}
</style>
<style scoped>
:deep(.vmsChangePermissions-title) {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
    margin-bottom: 20px;
}
:deep(.vmsChangePermissions-Wrapper) {
    display: flex;
}
:deep(.vmsChangePermissions-mainWrapper) {
    margin-top: 20px;
    width: 100%;
    display: inline-block;
}
:deep(.vmsChangePermissions-wrapper) {
    width: 100%;
    min-height: 200px;
    background-color: #fff;
    padding: 20px;
}
:deep(.vmsChangePermissions-header) {
    display: flex;
    margin-bottom: 5px;
    width: calc(100% - 20px);
}
:deep(.vmsChangePermissions-header-whiteSpace) {
    width: 100%;
    font-size: 14px;
}
:deep(.vmsChangePermissions-header-permLabelList) {
    display: flex;
}
:deep(.vmsChangePermissions-header-permLabel) {
    color: #303030;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    width: 20px;
    margin-left: 6px;
}
:deep(.vmsChangePermissions-header-permCheckbox) {
    margin-left: 8px;
}
:deep(.vmsChangePermissions-descriptionWrapper) {
    margin-top: 10px;
}
:deep(.vmsChangePermissions-listItemWrapper) {
    height: 120px;
    overflow-y: scroll;
    overflow-x: hidden;
}
:deep(.vmsChangePermissions-listItem) {
    display: flex;
    padding: 5px 0;
}
:deep(.vmsChangePermissions-listItem .clientName) {
    width: 100%;
    font-size: 14px;
}
:deep(.vmsChangePermissions-listItem .checkboxList) {
    display: flex;
    margin-right: 5px;
}
:deep(.vmsChangePermissions-listItem .permCheckbox) {
    display: inline-block;
    margin-left: 8px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsChangePermissions-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsChangePermissions-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
</style>
